import { Dispatch } from 'redux';
import { HomeViewRole } from '@app/constants/home';
import { EDUCATOR_ROLE } from '@core/constants/space';
import {
  HOME_REFRESH_SPACES_CARD_DATA_FAILURE,
  HOME_REFRESH_SPACES_CARD_DATA_REQUEST,
  HOME_REFRESH_SPACES_CARD_DATA_SUCCESS,
} from '@core/constants/actions';
import getHomeSpacesProgress from '@core/api/materials/getHomeSpacesProgress';
import getHomeSpacesEngagement from '@core/api/engagement/getHomeSpacesEngagement';

export const refreshHomeSpacesCardData =
  (spaceIds: string[], role: HomeViewRole) => async (dispatch: Dispatch) => {
    if (!spaceIds.length) {
      return;
    }

    dispatch({
      type: HOME_REFRESH_SPACES_CARD_DATA_REQUEST,
      role,
      spaceId: spaceIds[0],
    });

    try {
      const progressResponse = await getHomeSpacesProgress(spaceIds);
      const engagementResponse =
        role === EDUCATOR_ROLE
          ? await getHomeSpacesEngagement(spaceIds)
          : { spaceEngagement: [] };

      dispatch({
        type: HOME_REFRESH_SPACES_CARD_DATA_SUCCESS,
        role,
        progress: progressResponse.spaceProgress,
        engagement: engagementResponse.spaceEngagement,
      });
    } catch (error) {
      console.error('Failed to refresh home space card data', error);
      dispatch({
        type: HOME_REFRESH_SPACES_CARD_DATA_FAILURE,
        role,
        spaceId: spaceIds[0],
      });
    }
  };
